/**
 * useAppIsFramed
 *
 * A hook that determines if the app is running inside an iframe. We wrap this logic in a hook
 * so that the response can be mocked in tests, where `window.top` cannot be overridden.
 *
 * @returns A boolean indicating whether the app is framed.
 */
const useAppIsFramed = () => {
  return typeof window !== 'undefined' ? window.self !== window.top : false;
};

export default useAppIsFramed;
